export default function CTA() {
  return (
    <section id="cta" className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-indigo-600 to-purple-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
          Ready to Secure Your Online Privacy?
        </h2>
        <p className="text-xl text-indigo-100 mb-10 leading-relaxed">
          Join thousands of users who trust VOS VPN to protect their digital life. Start your journey to complete online privacy and security today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="mailto:contact@vos-systemdoozabalj.com"
            className="bg-white text-indigo-600 px-8 py-4 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all shadow-lg cursor-pointer whitespace-nowrap inline-block"
          >
            Contact Us
          </a>
          <a 
            href="tel:+18164764929"
            className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap inline-block"
          >
            Call Now
          </a>
        </div>
      </div>
    </section>
  );
}
